import { Fragment, memo } from 'react';
import { Transition, Menu } from '@headlessui/react';
import { Icon } from '@iconify-icon/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Button from '#lib/components/button.jsx';
import { mergeClasses } from '#lib/helpers/class.js';
import CogIcon from '@heroicons/react/24/outline/esm/CogIcon';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const ActionsButton = function (props) {
    const { onClick, disabled, className, isLoading } = props;

    return (
        <Menu as="div" className={mergeClasses('relative inline-block text-left w-full', className)}>
            <div>
                <Menu.Button
                    className={
                        'inline-flex w-full justify-center gap-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
                    }
                >
                    <span className="flex gap-1">
                        <CogIcon height="1.3rem" width="1.3rem" />
                        {_t.orders.actions()}
                    </span>

                    <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute right-3 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item key="import" disabled={disabled}>
                        <Button
                            onClick={() => onClick(disabled)}
                            className={classNames(
                                disabled
                                    ? 'text-slate-300 cursor-default hover:bg-gray-100 active:bg-white'
                                    : 'text-gray-900 cursor-pointer hover:text-gray-900 hover:bg-primary-50',
                                'block py-2 text-sm w-full flex gap-5 px-2 items-center transition-all duration-300 rounded-md'
                            )}
                        >
                            <span className="flex inset-0 justify-items-center gap-2">
                                <Icon icon="uil:import" width="1.2rem" height="1.2rem" />
                                {_t.orders.importSelected()}
                            </span>
                        </Button>
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    );
};

export default memo(ActionsButton);
